var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useEffect, useState } from 'react';
import QRCode from 'qrcode';
export function useQRCodeImages(items) {
    const [qrCodes, setQrCodes] = useState(new Map());
    useEffect(() => {
        let isMounted = true;
        const generateQrCodes = () => __awaiter(this, void 0, void 0, function* () {
            const nextQrCodes = new Map();
            for (const item of items) {
                const svg = yield QRCode.toString(item.url, {
                    type: 'svg',
                    errorCorrectionLevel: 'M',
                    margin: 0,
                    color: {
                        dark: '#000000',
                        light: '#0000'
                    }
                });
                const correctSvg = svg
                    .replace(/stroke="[^"]*"/, 'stroke="currentColor"')
                    .replace('<svg', '<svg focusable="false" aria-hidden="true"');
                nextQrCodes.set(item.id, correctSvg);
            }
            if (isMounted) {
                setQrCodes(nextQrCodes);
            }
        });
        void generateQrCodes();
        return () => {
            isMounted = false;
        };
    }, [items]);
    return qrCodes;
}
